import { Minus, Plus } from 'lucide-react';

interface StepperProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  label: string;
  unit?: string;
}

export function Stepper({ value, min, max, onChange, label, unit = '명' }: StepperProps) {
  return (
    <div className="flex items-center justify-between rounded-2xl border border-cream-300 bg-white px-3 py-2" role="group" aria-label={label}>
      <button type="button" className="btn-secondary h-11 w-11 !rounded-xl !p-0" onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min} aria-label="인원 줄이기">
        <Minus size={18} aria-hidden="true" />
      </button>
      <output className="text-2xl font-extrabold tabular-nums" aria-live="polite">
        {value}
        <span className="ml-0.5 text-base font-semibold text-charcoal-500">{unit}</span>
      </output>
      <button type="button" className="btn-secondary h-11 w-11 !rounded-xl !p-0" onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max} aria-label="인원 늘리기">
        <Plus size={18} aria-hidden="true" />
      </button>
    </div>
  );
}
